import React from 'react';
import { FileText } from 'lucide-react';

const TaxationSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-red-50 dark:bg-red-900/20 p-4 rounded-lg border border-red-200 dark:border-red-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <FileText className="w-5 h-5 mr-2 text-red-500" />
        Налогообложение
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Налоговая ставка */}
        <div>
          <label htmlFor="taxRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Налоговая ставка в России (%)
          </label>
          <input
            type="text"
            id="taxRate"
            name="taxRate"
            value={formData.taxRate}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.taxRate ? 'input-error' : ''}`}
            placeholder="Например: 13"
          />
          {errors.taxRate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.taxRate}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-gray-100 dark:bg-gray-800/50 p-3 rounded-lg border border-gray-200 dark:border-gray-700">
        <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-1">
          Важная информация о налогах в России
        </h4>
        <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-1 ml-4 list-disc">
          <li>
            С 1 января 2021 года доходы от операций с криптоактивами облагаются НДФЛ по ставке 13%
          </li>
          <li>
            Налог взимается с прибыли — разницы между доходами от продажи и расходами на приобретение
          </li>
          <li>
            Налогоплательщики обязаны самостоятельно декларировать доходы от операций с криптовалютой
          </li>
          <li>
            Налоговый вычет при долгосрочном владении (более 3 лет) не применяется к криптовалютам
          </li>
          <li>
            Неуплата налогов с криптовалютных операций может повлечь административную и уголовную ответственность
          </li>
        </ul>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-2 italic">
          Примечание: Налоговое законодательство может меняться. Рекомендуем проконсультироваться с налоговым специалистом.
        </p>
      </div>
    </div>
  );
};

export default TaxationSection;